'use client'; // This directive is essential!

import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { SliceZone } from '@prismicio/react';
import { components } from '@/slices';
import {
  PageDocument,
  PageDocumentDataSlicesSlice,
} from '../../../prismicio-types';

// --- Define Your Slice Order Here ---
const V1_ORDER: string[] = [
  'hero_cta_with_logos',
  'headline_with_stat_cards',
  'headline_centered_illustration',
  'headline_description_cta_steps',
  'feature_highlight_split',
  'testimonial_carousel',
  'hero_with_bullet_points',
  // ... add any other slice IDs for v1 in your desired order
];

const V2_ORDER: string[] = [
  'hero_cta_with_logos',
  'feature_highlight_split',
  'headline_description_cta_steps',
  'headline_with_stat_cards',
  'headline_centered_illustration',
  'testimonial_carousel',
  'hero_with_bullet_points',
  // ... add any other slice IDs for v2 in your desired order
];
// --- End of Slice Order Definition ---

// Define the types for the component's props
interface HomePageClientProps {
  page: PageDocument;
  remainingSlices?: PageDocumentDataSlicesSlice[];
}

export default function HomePageClient({
  page,
  remainingSlices,
}: HomePageClientProps) {
  const searchParams = useSearchParams();

  const [orderedSlices, setOrderedSlices] = useState<
    PageDocumentDataSlicesSlice[]
  >(remainingSlices || page.data.slices);

  useEffect(() => {
    const urlVersion = searchParams.get('v');
    let versionToUse = localStorage.getItem('homepageVersion') || 'v2';

    if (urlVersion && (urlVersion === 'v1' || urlVersion === 'v2')) {
      localStorage.setItem('homepageVersion', urlVersion);
      versionToUse = urlVersion;
    }

    const desiredOrder = versionToUse === 'v2' ? V2_ORDER : V1_ORDER;
    const orderMap = new Map(
      desiredOrder.map((sliceType, index) => [sliceType, index]),
    );

    const slicesToSort = remainingSlices || page.data.slices;
    const sortedSlices = [...slicesToSort].sort((a, b) => {
      const indexA = orderMap.get(a.slice_type);
      const indexB = orderMap.get(b.slice_type);

      if (indexA === undefined) return 1;
      if (indexB === undefined) return -1;

      return indexA - indexB;
    });

    setOrderedSlices(sortedSlices);
  }, [searchParams, page.data.slices, remainingSlices]);

  return (
    <div>
      <SliceZone slices={orderedSlices} components={components} />
    </div>
  );
}
